let hp_active = false;
if(window.location.href.indexOf("qa=GWP-HP") > -1){
  hp_active = true;
}

let hogwarts_active = false;
if(window.location.href.indexOf("qa=GWP-HOGWARTS") > -1){
  hogwarts_active = true;
}


let easter_active = true;
if(window.location.href.indexOf("qa=GWP-Easter") > -1){
  easter_active = true;
}

window.hidden_products = [
  {
    handle: "tiny-travel-scissors",
    var_id: "44193273020582",
    title: "Wee Woobly Scissors",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/Copy-of-Copy-of-TravelScissors4_110x110@2x.jpg?v=1686750142",
    active: true
  },{
    handle: "pig-crochet-hook",
    var_id: "44442679902374",
    title: "Pig Crochet Hook",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/88MYS-Hook-Teal-RET_2.jpg?v=1695748916",
    active: true
  },{
    handle: "pac-man-tin",
    var_id: "44497991532710",
    title: "PAC-MAN Tin",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/93TIN-PACMAN-Black-RET_1.jpg?v=1698079226",
    active: false
  },{
    handle: "peanuts-crochet-hook",
    var_id: "44557240860838",
    title: "Peanuts Crochet Hook",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/53SHK-Hook-GT2-RET.jpg?v=1699904846",
    active: false
  },{
    handle: "harry-potter-tin",
    var_id: "44800595787942",
    title: "Harry Potter Tin",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/93HPT-Tin-YGP32-WEB.jpg?v=1707400982",
    active: hp_active
  },{
    handle: "easter-pastel-hook",
    var_id: "44811311251622",
    title: "Easter Pastel Hook",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/55EHK-Hook-RVT3-WEB.jpg?v=1707915423",
    active: easter_active
  }, {
    handle: "rainbow-hook",
    var_id: "44181238022310"
  }, {
    handle: "mystery-accessory-1",
    var_id: "44266008707238"
  }, {
    title: "Exclusive Mystery Accessory",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/products/mystery-accessory-FINAL.png?v=1689394265",
    handle: "mystery-accessory",
    var_id: "45779459932326" //44265993109670 -- 44257547681958 -- 45487928672422
  }, {
    title: "Mystery Hook",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/mystery-hook-02.jpg?v=1699476684",
    handle: "mystery-hook",
    var_id: "44546700705958"
  }, {
    handle: "mystery-tin",
    var_id: "44398338605222"
  }, {
    handle: "mystery-tin",
    var_id: "44398338637990"
  }, {
    handle: "mystery-tin",
    var_id: "44398338670758"
  }, {
    title: "Mystery Tin",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/mystery-tin-01.jpg?v=1694095379",
    handle: "mystery-tin",
    var_id: "44398353088678"
  },{
    handle: "the-woobles-sticker-pack",
    var_id: "45637689966758",
    title: "The Woobles Sticker Pack",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/Retouched_Photography_Stickers_200x.jpg?v=1721241714",
    active: window.sessionStorage.getItem("woobles_sticker_pack_gwp")
  },
  {
    title: "Mystery Accessory",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/products/mystery-accessory-FINAL.png?v=1689394265",
    handle: "mystery-accessory-ii-kit",
    var_id: "45922275426470"
  },
  {
    title: "Mystery Accessory",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/products/mystery-accessory-FINAL.png?v=1689394265",
    handle: "mystery-accessory",
    var_id: "44265993109670"
  },
  {
    title: "Mystery Accessory",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/products/mystery-accessory-FINAL.png?v=1689394265",
    handle: "mystery-accessory",
    var_id: "44257547681958"
  },
  {
    title: "Mystery Accessory",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/products/mystery-accessory-FINAL.png?v=1689394265",
    handle: "mystery-accessory",
    var_id: "45487928672422"
  },
  {
    title: "Ollivanders™ Wand Custom Hook",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/HogwartsExpressCollectorsBox_14.jpg?v=1731418380",
    handle: "hogwarts™-express-custom-hook",
    var_id: "45948132917414",
    active: true
  },
  {
    title: "Holiday Sticker Pack",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/BFCM-Stickers-GT3-WEB.jpg?v=1732657706",
    handle: "holiday-sticker-pack",
    var_id: "45961509240998"
  },
  {
    title: "2024 Holiday Mystery Gift Pack",
    image: "https://cdn.shopify.com/s/files/1/0400/0904/0038/files/BFCM-StickersHookTin-GT3-WEB.jpg?v=1732657519",
    handle: "holiday-sticker-pack-custom-hook-and-tin",
    var_id: "45964988645542"
  },
  { "handle": "wooble-wagon-tin", "var_id": "46408915583142" }
];

/*

[WBLS-GWP] 

Travel Bundle Scissors GWP
1 free scissors PER EACH bundle buy

Pigasus and Pals Bundle GWP
1 free pig crochet hook per each

PAC-MAN-ificent Pals Bundle GWP
A-maze-ing Apparitions Bundle GWP
Leader of the PAC Bundle GWP
1 free PAC-MAN tin per each

Peanuts-Palooza Bundle GWP
Winter Is for the Birds Bundle GWP
Santa Paws Bundle GWP
Always Bea(gle) Prepared Bundle GWP
Doggone Snooperhero Bundle GWP
1 free peanuts crochet hook per each

Harry Potter Tin

Easter Hook

*/

let gwp_items_to_add = [];
window.gwp_qualifying_items = [];

if(window.hidden_products[0].active){
  window.gwp_qualifying_items.push({
    handle: "zoo-cation-crew-bundle",
    var_id: "44211070075046",
    gwp_id: 0
  }, {
    handle: "eat-paw-love-bundle",
    var_id: "44211036979366",
    gwp_id: 0
  }, {
    handle: "the-wooblehood-of-the-traveling-tails-bundle",
    var_id: "44210998706342",
    gwp_id: 0
  }, {
    handle: "passport-pals-bundle",
    var_id: "44203031330982",
    gwp_id: 0
  })
}

if(window.hidden_products[1].active){
  window.gwp_qualifying_items.push({
    handle: "pigasus-and-pals-bundle",
    var_id: "44432703029414",
    gwp_id: 1
  })
}

if(window.hidden_products[2].active){
  window.gwp_qualifying_items.push({
    handle: "pac-man-ificent-pals-bundle",
    var_id: "44458016866470",
    gwp_id: 2
  }, {
    handle: "a-maze-ing-apparitions-bundle",
    var_id: "44457999499430",
    gwp_id: 2
  }, {
    handle: "pac-man-bundle",
    var_id: "43970449834150",
    gwp_id: 2
  })
}

if(window.hidden_products[3].active){
  window.gwp_qualifying_items.push({
    handle: "doggone-snooperhero-bundle",
    var_id: "44454100140198",
    gwp_id: 3
  }, {
    handle: "always-beagle-prepared-bundle",
    var_id: "44588781830310",
    gwp_id: 3
  }, {
    handle: "santa-paws-bundle",
    var_id: "44454118162598",
    gwp_id: 3
  }, {
    handle: "winter-is-for-the-birds-bundle",
    var_id: "44454152765606",
    gwp_id: 3
  }, {
    handle: "peanuts-palooza-crochet-bundle",
    var_id: "44588781174950",
    gwp_id: 3
  })
}

if(window.hidden_products[4].active){
  window.gwp_qualifying_items.push({
    handle: "hogwarts™-houses-bundle",
    var_id: "44696059707558",
    gwp_id: 4
  }, {
    handle: "harry-potter™-x-the-woobles-bundle",
    var_id: "44696097554598",
    gwp_id: 4
  }, {
    handle: "ravenclaw™-raven-and-scarf-bundle",
    var_id: "44696118689958",
    gwp_id: 4
  }, {
    handle: "hufflepuff™-badger-and-scarf-bundle",
    var_id: "44696138121382",
    gwp_id: 4
  }, {
    handle: "gryffindor™-lion-and-scarf-bundle",
    var_id: "44696152408230",
    gwp_id: 4
  }, {
    handle: "slytherin™-serpent-and-scarf-bundle",
    var_id: "44696167317670",
    gwp_id: 4
  }, {
    handle: "harry-potter™-and-hedwig™-bundle",
    var_id: "44457864560806",
    gwp_id: 4
  }, {
    handle: "albus-dumbledore™-and-fawkes™-bundle",
    var_id: "44457856270502",
    gwp_id: 4
  }, {
    handle: "dobby™-and-dobbys™-sock-bundle",
    var_id: "44457839526054",
    gwp_id: 4
  }, {
    handle: "lord-voldemort™-and-nagini-bundle",
    var_id: "44457917612198",
    gwp_id: 4
  }, {
    handle: "wizarding-world-woobles-crochet-bundle",
    var_id: "44457926033574",
    gwp_id: 4
  })
}

if(window.hidden_products[5].active){
  window.gwp_qualifying_items.push({
    handle: "eggs-tremely-easter-rific-ensemble-bundle",
    var_id: "44696494473382",
    gwp_id: 5
  }, {
    handle: "somebunny-loves-you-bundle",
    var_id: "44807518486694",
    gwp_id: 5
  })
}
/*
if(window.hidden_products[19].active){
  window.gwp_qualifying_items.push({
    handle: "hogwarts-express-collectors-box",
    var_id: "45947717320870",
    gwp_id: 19
  })
}
*/